import { render, staticRenderFns } from "./diagrama.vue?vue&type=template&id=8cb36ef0&scoped=true"
import script from "./diagrama.vue?vue&type=script&lang=js"
export * from "./diagrama.vue?vue&type=script&lang=js"
import style0 from "./diagrama.vue?vue&type=style&index=0&id=8cb36ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb36ef0",
  null
  
)

export default component.exports